module.exports = __webpack_public_path__ + "public/images/schedule/schedule-rot.8f6c4def139abc19d35defa128500f2c.svg";